module.exports = __webpack_public_path__ + "static/media/bigWalrus.c926cefd.svg";